import { all, fork, takeEvery } from 'redux-saga/effects';
import {
  SET_UP_COMPANY,
  SIGN_UP_COMPANY,
  VALIDATE_EMAIL,
  LOAD_COMPANY_BILLING,
  LOAD_COMPANY_RATE,
  CHANGE_COMPANY_RATE,
  INVOICE_COMPANY,
  UNSET_COMPANY_INTEGRATION,
  UPDATE_COMPANY_MASTER_PASSWORD,
  CARD_INVOICE_SUCCESS,
  LOAD_ENTITIES_UPDATED,
  CREATE_COMPANY_EXPORT,
  DOWNLOAD_COMPANY_EXPORT,
} from 'constants/ActionTypes';
import { updateEntity, loadEntities } from 'helpers/utilHelpers';

function* signUpCompany() {
  yield takeEvery(SIGN_UP_COMPANY, updateEntity);
}

export function* loadEntitiesUpdatedSaga() {
  yield takeEvery(LOAD_ENTITIES_UPDATED, loadEntities);
}

function* setUpCompany() {
  yield takeEvery(SET_UP_COMPANY, updateEntity);
}

function* validateEmail() {
  yield takeEvery(VALIDATE_EMAIL, updateEntity);
}

function* loadCompanyBilling() {
  yield takeEvery(LOAD_COMPANY_BILLING, loadEntities);
}

function* loadCompanyRates() {
  yield takeEvery(LOAD_COMPANY_RATE, loadEntities);
}

function* changeCompanyRate() {
  yield takeEvery(CHANGE_COMPANY_RATE, updateEntity);
}

function* invoiceCompany() {
  yield takeEvery(INVOICE_COMPANY, updateEntity);
}

function* cardInvoiceSuccess() {
  yield takeEvery(CARD_INVOICE_SUCCESS, loadEntities);
}

function* unsetCompanyIntegration() {
  yield takeEvery(UNSET_COMPANY_INTEGRATION, updateEntity);
}

function* updateCompanyMasterPassword() {
  yield takeEvery(UPDATE_COMPANY_MASTER_PASSWORD, updateEntity);
}

function* createCompanyExportSaga() {
  yield takeEvery(CREATE_COMPANY_EXPORT, loadEntities);
}

function* downloadExportSaga() {
  yield takeEvery(DOWNLOAD_COMPANY_EXPORT, updateEntity);
}

export default function* rootSaga() {
  yield all([
    fork(signUpCompany),
    fork(loadEntitiesUpdatedSaga),
    fork(setUpCompany),
    fork(loadCompanyBilling),
    fork(loadCompanyRates),
    fork(changeCompanyRate),
    fork(invoiceCompany),
    fork(unsetCompanyIntegration),
    fork(updateCompanyMasterPassword),
    fork(cardInvoiceSuccess),
    fork(createCompanyExportSaga),
    fork(downloadExportSaga),
    fork(validateEmail),
  ]);
}
